import React from 'react';
import { Swiper } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import * as styles from './styles.module.scss';
import Icon from '../icon';

const Carousel = ({ children }) => {
  return (
    <>
      <div className="swiper-button-prev">
        <Icon name="chevron-left" color="#da1720" />
      </div>
      <Swiper
        slidesPerView={1}
        modules={[Navigation, Pagination]}
        pagination={{ clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        autoHeight
        className={styles.carousel}
      >
        {children}
      </Swiper>
      <div className="swiper-button-next">
        <Icon name="chevron-right" color="#da1720" />
      </div>
    </>
  );
};

export default Carousel;
